// Catálogo de cargas típicas (cuadro de cargas off-grid).
//
// La lista CANÓNICA vive en `src/motores/catalogoCargas.js` — un solo ejemplar, que también sirve
// el backend por `/hub-api/loads-catalog`. Acá se reexporta con el nombre histórico porque la UI
// del cuadro de cargas ya lo importa así.
//
// Primario: `/hub-api/loads-catalog` (Express). Antes apuntaba a un webhook que nunca existió, y por
// eso el endpoint devolvía 404 y el off-grid se dimensionaba siempre con el respaldo local.
// Respaldo: la misma lista canónica. Cacheado en localStorage 7 días.

import { hubPost, hubConfigurado } from './hub';
import { CARGAS_TIPICAS } from '../motores/catalogoCargas.js';

const CACHE_KEY = 'loads:catalog';
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

/** Respaldo local = catálogo canónico. `peakWatts` = arranque inductivo (dimensiona el inversor). */
export const DEFAULT_LOADS_CATALOG = CARGAS_TIPICAS;

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (Date.now() - p.t > TTL_MS) return null;
    return p.d;
  } catch { return null; }
}

function writeCache(data) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data })); } catch {}
}

export async function fetchLoadsCatalog() {
  const cached = readCache();
  if (cached?.items?.length) return { ...cached, cached: true };
  if (!hubConfigurado()) {
    return { ok: true, items: DEFAULT_LOADS_CATALOG, source: 'local-default' };
  }
  try {
    const data = await hubPost('loads-catalog', {});
    if (Array.isArray(data?.items) && data.items.length) {
      writeCache(data);
      return data;
    }
    return { ok: true, items: DEFAULT_LOADS_CATALOG, source: 'local-default', notes: data?.error || 'catálogo remoto vacío' };
  } catch (e) {
    return { ok: true, items: DEFAULT_LOADS_CATALOG, source: 'local-default', notes: e?.message || 'sin conexión' };
  }
}

export function invalidateLoadsCache() {
  try { localStorage.removeItem(CACHE_KEY); } catch {}
}
